import React from 'react';
import { IconContainer } from './IconContainer';

const DoneIcon = (props) => {
    return (
        <IconContainer active ariaLabel="done" cursor="pointer" {...props}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99996 18.3333C5.39746 18.3333 1.66663 14.6025 1.66663 9.99996C1.66663 5.39746 5.39746 1.66663 9.99996 1.66663C14.6025 1.66663 18.3333 5.39746 18.3333 9.99996C18.3333 14.6025 14.6025 18.3333 9.99996 18.3333ZM9.99996 16.6666C11.7681 16.6666 13.4638 15.9642 14.714 14.714C15.9642 13.4638 16.6666 11.7681 16.6666 9.99996C16.6666 8.23185 15.9642 6.53616 14.714 5.28591C13.4638 4.03567 11.7681 3.33329 9.99996 3.33329C8.23185 3.33329 6.53616 4.03567 5.28591 5.28591C4.03567 6.53616 3.33329 8.23185 3.33329 9.99996C3.33329 11.7681 4.03567 13.4638 5.28591 14.714C6.53616 15.9642 8.23185 16.6666 9.99996 16.6666ZM9.16913 13.3333L5.63329 9.79746L6.81163 8.61913L9.16913 10.9766L13.8825 6.26246L15.0616 7.44079L9.16913 13.3333Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { DoneIcon };